import createBaseService from "@/api/base-service.ts";
import type { Province } from "../../types/province";

const provinceService = {
	...createBaseService<Province>("/provinces"),
};

export default provinceService;
